<template>
  <v-app>
    <!--layout-app-app-bar /-->
    <layout-pos-drawer :key="keyRender" />

    <layout-pos-view />
    <button
      v-if="hayAviso && avisoOculto"
      type="button"
      class="aviso-pedidos-burbuja"
      :title="totalPorRecibir > 1 ? totalPorRecibir + ' pedidos por aceptar' : 'Pedido por aceptar'"
      @click="avisoOculto = false"
    >
      <v-icon color="white">mdi-bell-ring-outline</v-icon>
      <span class="aviso-pedidos-burbuja__cuenta" v-if="totalPorRecibir">{{ totalPorRecibir }}</span>
    </button>
    <div
      v-if="hayAviso && !avisoOculto"
      class="aviso-pedidos"
      :class="{ 'aviso-pedidos--movil': $store.getters.mobile }"
      role="alert"
    >
      <span class="aviso-pedidos__icono"><v-icon color="white">mdi-bell-ring-outline</v-icon></span>
      <div class="aviso-pedidos__texto">
        <strong>{{ totalPorRecibir > 1 ? totalPorRecibir + " pedidos por aceptar" : "Pedido por aceptar" }}</strong>
        <span>Esperan a que la caja los acepte</span>
      </div>
      <v-btn depressed color="primary" class="aviso-pedidos__boton" @click="openModalOrdersReceived">
        <v-icon left small>mdi-eye-outline</v-icon>Ver pedidos
      </v-btn>
      <v-btn icon small class="aviso-pedidos__cerrar" title="Ocultar el aviso (queda la campana para volver a abrirlo)" @click="avisoOculto = true">
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </div>
    <CartPendingOrdersReceived
      :dialog="showModalOrdersReceived"
      @cancel="showModalOrdersReceived = false"
      @close="showModalOrdersReceived = false"
      @order:acepted="orderAcepted"
      ref="modalOrdersReceived"
    >
    </CartPendingOrdersReceived>
    <PosTour />
  </v-app>
</template>



<script>
import { vigilarAgotados } from "@/plugins/pos/agotados";
import {
  //isStoreActive,
  existsStore,
  createStore,
  ping,
  setTokenFcm,
} from "@/plugins/db-firestore";
import CartPendingOrdersReceived from "@/components/modules/pos/components/CartPendingOrdersReceived.vue";
import PosTour from "@/components/modules/pos/components/PosTour.vue";

export default {
  name: "PosIndex",
  components: { CartPendingOrdersReceived, PosTour },
  data: () => ({
    expandOnHover: false,
    keyRender: 0,
    ws: null,
    totalPorRecibir: 0,
    showModalOrdersReceived: false,
    avisoOculto: false
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    },
    // El aviso de «orden por recibir» solo sale con la caja lista: equipo instalado y turno abierto. Con
    // la instalación o la apertura de turno a medias taparía esas pantallas.
    cajaAbierta() {
      return !!this.$store.getters.installation && !!this.$store.getters.turn;
    },
    hayAviso() {
      return !!this.$store.getters.orderReceived && this.cajaAbierta && !this.getIsSellDoorToDoor();
    },
  },
  watch: {
    // El aviso se puede ocultar (queda una campana para reabrirlo), pero un pedido nuevo lo vuelve a mostrar.
    totalPorRecibir(nuevo, viejo) {
      if (nuevo > viejo) {
        this.avisoOculto = false;
      }
    },
    //installation
    async user(val) {
      if (val) {
        let installation = this.$store.getters.installation;
        if(this.$store.getters.getGeneralValue('gen_sales_manage_screens') || 
        this.$store.getters.getGeneralValue('gen_sales_manage_waiters') ||
        this.$store.getters.getGeneralValue('gen_sales_manage_delivery')){
            let st = await existsStore(installation.subsidiary_id);
            console.log('st',st);
            //gen_sales_manage_screens, gen_sales_manage_waiters, gen_sales_manage_delivery
            if (!st) {
              createStore(installation.subsidiary_id);
            } else {
              ping(installation.subsidiary_id);
              setTokenFcm(this.$http);
            }
      }
        this.loadTurn();
      }
    },
    "$store.getters.orderReceived": function (val) {
      // Al llegar un aviso se vuelve a contar cuántos esperan; al aceptarlos todos, el contador queda en cero.
      if (val) {
        this.getTotalOrdersToReceive();
      } else {
        this.totalPorRecibir = 0;
        this.avisoOculto = false;
      }
    },
  },
  mounted() {
    vigilarAgotados(this.$http);

    setTimeout(() => {
      //console.log('1111111111111111111111111111111111')
      if (!this.user) {
        this.$router.push("/login");
      } else {
        this.getTotalOrdersToReceive();
      }
    }, 1000);
   /* let count = 1;
    setInterval(() => {
      count++;
      let v = count % 2 ? true : false;
      console.log("borrar...");
      this.$store.commit("setOrderReceived", v);
    }, 2000);*/
  },
  methods: {
    orderAcepted() {
      this.$store.commit("setOrderReceived", true);
    },
     getIsSellDoorToDoor() {
      let value = this.$store.getters.getGeneralValue(
        "gen_sales_activate_door_to_door_sales"
      );
      return value;
    },
    async getTotalOrdersToReceive() {
      let installation = this.$store.getters.installation;
      if (!installation) return;
      this.$http
        .get("api/v1/orders-to-receive-total", {
          //from_seller: true,
          //order_status: "pending",
          subsidiary: [installation.subsidiary_id],
        })
        .then((response) => {
          this.totalPorRecibir = response.total || 0;
          if (response.total > 0) {
            this.$store.commit("setOrderReceived", true);
          }
        });
    },

    loadTurn() {
      const installation = this.$store.getters.installation;
      // console.log('installation',installation);
      if (!installation) {
        return;
      }
      const cash_register = installation.cash_id;
      this.$http
        .get(
          "api/v1/pos/current-turn/" +
            this.$store.getters.installation.subsidiary_id,
          { cash_register: cash_register }
        )
        .then((response) => {
          if (response.success) {
            //console.log(response)
            this.$store.commit("setTurn", response.turn);

            // console.log("turn", response.turn);
          }
        })
        .catch((e) => {});
    },
    openModalOrdersReceived() {
      this.showModalOrdersReceived = true;
      this.$refs.modalOrdersReceived.getPendingOrders();
    },
  },
};
</script>
<style>
.v-main {
  background: #fafafa !important;
}

.v-main__wrap {
  padding-top: 21px !important;
}

@media only screen and (max-width: 981px) {
  .v-main__wrap {
    padding-top: 90px !important;
  }
}

.v-item--active {
  font-weight: 400 !important;
  font-size: 0.875rem !important;
}

.v-btn-toggle > .v-btn.v-btn {
  opacity: 1;
}
.aviso-pedidos {
  position: fixed;
  top: 76px;
  left: 50%;
  z-index: 1000;
  display: flex;
  align-items: center;
  gap: 14px;
  width: min(560px, calc(100% - 24px));
  padding: 10px 12px 10px 14px;
  transform: translateX(-50%);
  border-radius: 12px;
  border-left: 6px solid #ffab00;
  background: #fff;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.22);
}

.aviso-pedidos__icono {
  position: relative;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ffab00;
}

.aviso-pedidos__icono::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 2px solid #ffab00;
  animation: aviso-pedidos-pulso 1.6s ease-out infinite;
}

@keyframes aviso-pedidos-pulso {
  from {
    transform: scale(1);
    opacity: 0.8;
  }
  to {
    transform: scale(1.7);
    opacity: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .aviso-pedidos__icono::after {
    animation: none;
  }
}

.aviso-pedidos__texto {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.25;
}

.aviso-pedidos__texto strong {
  font-size: 1rem;
}

.aviso-pedidos__texto span {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
}

.aviso-pedidos--movil {
  gap: 10px;
}

.aviso-pedidos--movil .aviso-pedidos__texto span {
  display: none;
}
.aviso-pedidos__cerrar {
  flex: none;
  margin-left: -4px;
}

.aviso-pedidos-burbuja {
  position: fixed;
  top: 76px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #ffab00;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);
  animation: aviso-pedidos-pulso-burbuja 1.8s ease-out infinite;
}

.aviso-pedidos-burbuja__cuenta {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  border-radius: 10px;
  background: #c62828;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
}

@keyframes aviso-pedidos-pulso-burbuja {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 171, 0, 0.6);
  }
  100% {
    box-shadow: 0 0 0 16px rgba(255, 171, 0, 0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .aviso-pedidos-burbuja {
    animation: none;
  }
}
</style>